const meta = (
  import.meta as unknown as { env: Record<string, string | undefined> }
).env;

export const API_BASE_URL = meta.VITE_API_BASE_URL ?? "http://localhost:4000";
export const WEB_APEX_URL = meta.VITE_WEB_APEX_URL ?? "http://localhost:3000";
export const APP_URL = meta.VITE_APP_URL ?? "http://localhost:3001";
export const ADMIN_URL = meta.VITE_ADMIN_URL ?? "http://localhost:3002";

// Sentry DSN is a public client-side identifier (safe to ship). Default to the
// employer-web project DSN; override per-environment with VITE_SENTRY_DSN.
export const SENTRY_DSN =
  meta.VITE_SENTRY_DSN ??
  "https://a575fa8879fba2799ca3f53864ec1077@o4511262510350336.ingest.de.sentry.io/4511469043122256";
export const MODE = meta.MODE ?? "development";
export const IS_PROD = MODE === "production";

// Firebase Web (GA4) config. Create a Web App in the Firebase console for
// project chotca-86f6b and copy its config into a .env file as VITE_FIREBASE_*.
// When apiKey or measurementId is missing, analytics silently no-ops, so the
// app still runs fine locally without these set.
export const FIREBASE_CONFIG = {
  apiKey: meta.VITE_FIREBASE_API_KEY ?? "",
  authDomain: meta.VITE_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: meta.VITE_FIREBASE_PROJECT_ID ?? "",
  storageBucket: meta.VITE_FIREBASE_STORAGE_BUCKET ?? "",
  messagingSenderId: meta.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "",
  appId: meta.VITE_FIREBASE_APP_ID ?? "",
  measurementId: meta.VITE_FIREBASE_MEASUREMENT_ID ?? "",
};
